import { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import axios from 'axios';
import { Company } from 'src/api/requests';

export function useCompanyAutocomplete() {
  // START - findCompany (Previous dev code. Git history - MasterFileCreate .jsx)
  const [companyOptions, setCompanyOptions] = useState([]);
  const [companyQuery, setCompanyQuery] = useState('');
  const [debouncedText] = useDebounce(companyQuery, 500);
  const [companyRes, setCompanyRes] = useState([]);
  const [companyIsLoading, setCompanyIsLoading] = useState(false);
  const [companyIsError, setCompanyIsError] = useState(false);
  const [claimedCompaniesOptions, setClaimedCompaniesOptions] = useState([]);

  const companyFindReq = async (query, axiosSource) => {
    let res;
    setCompanyIsLoading(true);
    try {
      res = await Company.find({ query }, axiosSource.token);
      setCompanyRes(res.data);
    } catch (e) {
      if (axios.isCancel(axiosSource)) {
        return;
      }
      setCompanyRes([]);
      setCompanyIsLoading(false);
      setCompanyIsError(true);
    }
    setCompanyIsLoading(false);
  };

  useEffect(() => {
    if (companyRes && companyRes.length) {
      setCompanyOptions(companyRes);
    }
  }, [companyRes]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (debouncedText) {
      companyFindReq(debouncedText, source);
    } else {
      setCompanyRes([]);
    }
    return () => {
      source.cancel('Canceled because of component unmounted or debounce Text changed');
    };
  }, [debouncedText]);
  // END - findCompany

  return {
    companyOptions,
    setCompanyQuery,
    companyIsLoading,
    companyIsError,
    claimedCompaniesOptions,
    setClaimedCompaniesOptions,
    companyQuery,
  };
}
